// Minimum of 1 review required to show star ratings is determined by SHOW_SHEF_RATINGS experiment results:
// https://www.notion.so/Test-Debriefs-Meeting-Notes-ca660ef523d842c08c47e3eb7475424d
export const shouldShowStars = (numRatings: number) => numRatings >= 1;

export const useIsReviewsExperience = (numRatings: number, isTrialShef: boolean) => {
  const shouldUseReviews = shouldShowStars(numRatings) && !isTrialShef;
  return {
    shouldUseReviews,
  };
};
